module.exports = __webpack_public_path__ + "static/media/SIP-T29G_large.e834d22c.png";